import {
    CANCEL_PROSPECTS,
    ADDRESS_SELECTED,
    CENTER_MAP,
    SET_COORDINATES,
    SET_LOCAL_INIT,
    INIT_PROSPECT,
    UNSET_COORDINATES,
    CHANGE_COORD,
    PROSPECT_SHOW,
    SET_PROVIDERS,
    PROSPECT_FINISHED,
    SET_PROSPECT,
    ADD_CLICK,
    SET_GPS_ORIGINAL_LOCATION,
    BACK_TO_GPS,
    UPDATE_PROSPECT,
    NEW_PROVIDER_NAME
    
} from '../mutations';

import ProspectService from '../../services/models/ProspectService';

const prospectService = ProspectService.build();

export default {

        namespaced: true,

        state: {

            prospect: null,
            prospect_has_coordinates: false,
            gpsOriginalLocation: {} 
        },

        getters: {

            prospect: state => state.prospect,
            prospect_has_coordinates: state => state.prospect_has_coordinates,
            gpsOriginalLocation: state => state.gpsOriginalLocation,

        },

        mutations: {

            [SET_COORDINATES]: (state, { coordinates: { lat, lng } }) => {
                state.prospect.viability.coordinates = [lng, lat];
                state.prospect_has_coordinates = true;
            },

            [SET_GPS_ORIGINAL_LOCATION]: (state, coords) => {
                state.gpsOriginalLocation = coords;
            },

            [UNSET_COORDINATES]: (state) => {

                state.prospect.viability.coordinates = null;
                state.prospect_has_coordinates = false;
               
            },
            [SET_PROSPECT]: (state, newState) => {

                state.prospect = newState;
               
            },

        },

        actions: {

            [INIT_PROSPECT]: async function({ commit }, prospect_data) {

                const data = { type: prospect_data.type, locale: prospect_data.locale, viability: { coordinates: null } }
    
                const prospect = await prospectService.create(data);

                commit(SET_PROVIDERS, [], { root: true })

                commit(SET_PROSPECT, {})

                commit(SET_PROSPECT, { ...prospect })

            },

            [CANCEL_PROSPECTS]: async (context, unregisterData) => {

                return await prospectService.unregisterEmail(unregisterData);

            },

            [BACK_TO_GPS]: async ({ commit }, coords) => {
  
                commit(SET_COORDINATES, { coordinates: coords.coordinates });

                commit(CENTER_MAP, coords.coordinates, { root: true });

                return

            },

            [NEW_PROVIDER_NAME]: async (context, providerName) => {
  
                const eventSent = await prospectService.suggestProvider(providerName).catch((err) => { throw new Error(err) })

                return eventSent

            },

            [ADDRESS_SELECTED]: async ({ state, commit }, { searched_address, coordinates, status, gps_precision, device_info, search_method }) => {

                commit(CENTER_MAP, coordinates, { root: true });

                commit(SET_COORDINATES, { coordinates });

                commit(SET_LOCAL_INIT, true, { root: true });

                if (state.prospect?.status === 'Scanned' || state.prospect?.status === 'Clicked' ) {

                    const prospect = { ...state.prospect }

                    delete prospect._id

                    const dataToSave = { 
                        ...prospect, 
                        status, 
                        viability: [{ 
                            searched_address: searched_address || undefined, 
                            gps_precision, 
                            device_info, 
                            search_method,
                            coordinates: [coordinates.lng, coordinates.lat] 
                        }],
                    }

                    const newProspect = await prospectService.create(dataToSave);

                    commit(SET_PROVIDERS, [], { root: true })

                    commit(SET_PROSPECT, {})

                    commit(SET_PROSPECT, { ...newProspect })

                } 

                else {

                    commit(SET_PROSPECT, { 
                        ...state.prospect, 
                        status, 
                        viability: [{ 
                            searched_address: searched_address || undefined, 
                            gps_precision, 
                            device_info, 
                            search_method,
                            coordinates: [coordinates.lng, coordinates.lat] 
                        }],
                    })
                    
                    await prospectService.update({ ...state.prospect });

                }

            },

            [CHANGE_COORD]: async ({ state, commit }) => {

                if (!state.prospect?.viability?.coordinates) return

                commit(UNSET_COORDINATES, null, { root: true });
                commit(UNSET_COORDINATES);
                
            },

            [ADD_CLICK]: async ({ commit }, click) => {

                const updatedProspect = await prospectService.addClick(click).catch((err) => { throw new Error(err) })

                commit(SET_PROSPECT, updatedProspect)

                return updatedProspect
                
            },

            [UPDATE_PROSPECT]: async (context, prospect) => {

                await prospectService.update(prospect);
                
            },

            [PROSPECT_SHOW]: async ({ state, commit }) => {
			
                const providers_data = await prospectService.listViabilityProviders(state.prospect).catch((err) => { throw new Error(err) })

                if (!providers_data.providers.length) {

                    commit(SET_PROSPECT, providers_data.prospect)

                    return false

                } 
                
                commit(SET_PROVIDERS, providers_data.providers, { root: true })

                commit(SET_PROSPECT, providers_data.prospect)

                return providers_data 

            },

            [PROSPECT_FINISHED]: async ({ commit, rootState }, prospect) => {

                prospect.status = 'Finished'

                try {

                    const endProspect = await prospectService.endProspect({ prospect, providers: rootState.providers })

                    commit(SET_PROVIDERS, [], { root: true })

                    commit(SET_PROSPECT, {})

                    return endProspect

                    
                } catch (error) {

                    console.log(error) 

                    throw error
                    
                }                   
            },
        }
}